import { categories, eras } from "@/mocks/archive";

export function getCategoryName(id: string): string {
  const found = categories.find((c) => c.id === id);
  return found ? found.name : "档案";
}

export function getCategoryIcon(id: string): string {
  const found = categories.find((c) => c.id === id);
  return found ? found.icon : "ri-archive-line";
}

export function getEraName(id: string): string {
  const found = eras.find((e) => e.id === id);
  return found ? found.name : "";
}

export function getEraShort(id: string): string {
  const found = eras.find((e) => e.id === id);
  return found ? found.short : "";
}

export function getEventById<T extends { id: string }>(list: T[], id: string): T | undefined {
  return list.find((item) => item.id === id);
}